export default "__VITE_ASSET__DdvhSRP$__"